import { Avatar } from '@mui/material';

type IncImageCellProps = {
  value?: string[];
};

const IncImageCell = ({ value = [] }: IncImageCellProps) =>
  value.length > 0 ? (
    <Avatar variant="rounded" src={value[0]} data-testid="IncImageCell" />
  ) : null;

export default IncImageCell;
